import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useWishlist } from '../Context/WishlistContext'
import { useAuth } from '../Context/AuthContext'

function WishlistIcon({ onClick, label }) {
  const navigate = useNavigate()
  const { getWishlistCount } = useWishlist()
  const { isAuthenticated } = useAuth()
  const count = getWishlistCount()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else if (isAuthenticated) {
      navigate('/wishlist')
    } else {
      navigate('/login')
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="fab-header-action"
      aria-label={`Wishlist (${count} items)`}
      title="Wishlist"
    >
      <i className="fa-solid fa-heart" aria-hidden="true" />
      {count > 0 ? (
        <span className="fab-header-action__badge">{count > 99 ? '99+' : count}</span>
      ) : null}
      {label ? <span className="fab-header-action__label">{label}</span> : null}
    </button>
  )
}

export default WishlistIcon
